/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { YookassaNotification } from "../../entities/yookassa/Notification";
import { yookassaPaymentSchema } from "./paymentSchema";
import { z } from "zod/v4";

export const yookassaNotificationSchema = z.object({
    "event": z.optional(z.string()),
get "object"(){
                return yookassaPaymentSchema.optional()
              },
"type": z.optional(z.string())
    }) as unknown as z.ZodType<YookassaNotification>